import { render, staticRenderFns } from "./EmbeddedChatConversationQuickReply.vue?vue&type=template&id=2f7039bb&"
import script from "./EmbeddedChatConversationQuickReply.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedChatConversationQuickReply.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports